<template>
  <div
    id="slug"
    class="d-flex justify-center"
  >
    <div class="article-content">
      <div class="workspace-block">
        <div class="d-flex align-start">
          <div class="flex-grow-1">
            <span class="text-caption-primary">
              {{ $t('article.urlSuggestion.ideal') }}:&nbsp;
            </span>
            <span
              class="to-highlight-part"
              v-html="sanitizeHTML(highlightWords(suggestedUrl),{
                allowedAttributes: allowedAttributes
              })"
            />
            <div
              v-if="isAnalyze"
              class="text-caption text--secondary mt-1"
            >
              {{ $t('article.urlSuggestion.redirectNote') }}
            </div>
            <div v-if="articleHasUrl">
              <span class="text-caption-primary">
                {{ $t('article.urlSuggestion.yours') }}:&nbsp;
              </span>
              <span
                class="to-highlight-part"
                v-html="sanitizeHTML(highlightWords($store.getters.article.url),{
                  allowedAttributes: allowedAttributes
                })"
              />
            </div>
          </div>
          <LucySpark metric="keywordInSlug" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">

    import Vue from 'vue';
    import HighlightWordsMixin from "@/mixins/HighlightWordsMixin";
    import sanitizeHTML from 'sanitize-html';
    import {getBaseUrl, FALLBACK_URL, getSuggestedUrl} from '@/utils/ArticleUrl';
    import LucySpark from '@/components/lucy/LucySpark.vue';

    export default Vue.extend({
        name: "ArticleURLSuggestion",
        components: {LucySpark},
        mixins: [HighlightWordsMixin],
        data: () => ({
            sanitizeHTML: sanitizeHTML,
        }),
        computed: {
            articleHasUrl: function (): boolean {
                return !!this.$store.getters.article.url;
            },
            isAnalyze: function (): boolean {
                return !!this.$store.getters.article.isAnalyze;
            },
            baseUrl: function (): string {
                const url = this.$store.getters.article.url;
                return url !== '' ? getBaseUrl(url) : FALLBACK_URL
            },
            allowedAttributes: function () {
                const allowedAttributes = sanitizeHTML.defaults.allowedAttributes;
                allowedAttributes['mark'] = ['class'];
                return allowedAttributes;
            },
            suggestedUrl: function (): string {
                return getSuggestedUrl(this.baseUrl, this.$store.getters.article.selectedKeyword);
            },
        },
    });
</script>

<style scoped>

</style>
